
import React from 'react';

export default function Hero() {
    return (
        <section className="hero">
            <div className="hero-body">
                <div className="container">
                    <div className="row">
                        <div className="col-12 ">
                            {/*<a onClick={() => window.close() }><img src="bicsi-cares-one-line-red-min.png" alt="Bicsi Cares" /></a>*/}
                            <p className="margin-top:50px;">
                            </p>
                            <img className="img-fluid" src="shutterstock_1224366490.jpg" alt="Working" height="466px"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}